import { useQuery } from 'react-query';

import { fetchDataIntegration } from "./services/DataIntegrationService";

import { CACHE_TTL_MS } from './ttl.cache';

export const useDataIntegration = () => {
  const dataIntegrationQuery = useQuery({
    queryKey: ["data-integration"],
    queryFn: async () => {
      const data = await fetchDataIntegration();
      return data;
    },
    staleTime: CACHE_TTL_MS.TTL_15_MINUTES,
    cacheTime: CACHE_TTL_MS.TTL_1_HOUR,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: (failureCount, error) => {
      if (error?.response?.status === 401) return false;
      return failureCount < 2;
    },
    onError: (error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("exp");
        localStorage.removeItem("store-information");
        localStorage.removeItem("active-store");
        window.location.href = '/';
      }
    },
  });

  return {
    dataIntegration: dataIntegrationQuery.data?.dataIntegration,
    hierarchy: dataIntegrationQuery.data?.hierarchy,
    isLoadingDataIntegration: dataIntegrationQuery.isLoading,
    dataIntegrationError: dataIntegrationQuery.error,
  };
};
